import { useState } from "react";
import { motion } from "framer-motion";
import { Mail, Send, Check } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

export const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [prenom, setPrenom] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await api.post("/newsletter/subscribe", { email, prenom });
      setDone(true);
      toast.success("Bienvenue dans la Newsletter Répit", {
        description: "Un e-mail de bienvenue vient de partir.",
      });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Inscription impossible");
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        data-testid="newsletter-success"
        className="flex items-center gap-3 rounded-2xl border border-pblv-rose/40 bg-pblv-rose/10 p-4 text-sm text-pblv-bg"
      >
        <Check className="h-5 w-5 text-pblv-rose" strokeWidth={2} />
        <p>
          Merci ! Vous êtes bien inscrite à la <b>Newsletter Répit</b>.
        </p>
      </motion.div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="newsletter-form"
      className="flex flex-col gap-3"
    >
      <input
        type="text"
        placeholder="Votre prénom (optionnel)"
        value={prenom}
        onChange={(e) => setPrenom(e.target.value)}
        data-testid="newsletter-prenom"
        className="w-full rounded-full border border-white/15 bg-white/5 px-4 py-3 text-sm text-pblv-bg placeholder:text-pblv-bg/40 focus:border-pblv-rose focus:outline-none"
      />
      <div className="relative">
        <Mail className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-pblv-bg/60" strokeWidth={1.8} />
        <input
          type="email"
          required
          placeholder="votre.email@exemple.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="newsletter-email"
          className="w-full rounded-full border border-white/15 bg-white/5 py-3 pl-11 pr-4 text-sm text-pblv-bg placeholder:text-pblv-bg/40 focus:border-pblv-rose focus:outline-none"
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        data-testid="newsletter-submit"
        className="group inline-flex items-center justify-center gap-2 rounded-full bg-pblv-rose px-6 py-3 text-sm font-semibold text-pblv-ink transition-all duration-300 hover:-translate-y-0.5 hover:bg-white disabled:opacity-60"
      >
        {submitting ? "Envoi…" : "S'inscrire à la Newsletter Répit"}
        <Send className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={1.8} />
      </button>
    </form>
  );
};

export default NewsletterForm;
